import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getOptionById, createOption } from '../../actions/optionfichegrue';
import { getPiecesBySeq } from '../../actions/piece';
import { useParams, useNavigate } from 'react-router-dom';
import { MdSave } from 'react-icons/md';
import { MdCancel } from 'react-icons/md';
import ListePiecesJointes from '../duplication/ListePiecesJointes';
import ModalImportPJ from '../duplication/ModalImportPJ';
import Spinner from '../layout/Spinner';
import ElementNomenclature from '../nomenclaturebase/ElementNomenclature';
import { setAlert } from '../../actions/alert';
import { IoIosAddCircleOutline } from 'react-icons/io';
import { MdDelete } from 'react-icons/md';

const initialState = {
  nom: '',
  refx3: '',
  commentaire: '',
  typemc600: '603',
  piecesjointes: [],
  bom: []
};

const CreationOption = ({
  setAlert,
  getOptionById,
  getPiecesBySeq,
  createOption,
  optionfichegrue: { option, loadingopt, update },
  piece: { pieces, loadingpiece }
}) => {
  const { id, typeMC600 } = useParams();
  const navigate = useNavigate();

  const [formDataOption, setFormDataOption] = useState(initialState);
  const [listSeq, setListSeq] = useState([]);
  const [newBOM, setNewBom] = useState([]);
  const [newPieces, setNewPieces] = useState([]);
  const [listPiecesParSeq, setListPiecesParSeq] = useState([]);
  const [listPiecesExclues, setListPiecesExclues] = useState([]);
  const [action, setaction] = useState(false);

  useEffect(() => {
    if (id !== '0') {
      getOptionById(id);
      getPiecesBySeq(typeMC600 === '602' ? '602' : '603');
    }
    //Recuperation de la liste des pieces pour pouvoir afficher piece possible
  }, [getOptionById, getPiecesBySeq, id]);

  useEffect(() => {
    if (id === '0' && formDataOption.typemc600) {
      getPiecesBySeq(formDataOption.typemc600 === '603' ? '603' : '602');
    }
  }, [formDataOption.typemc600, id, getPiecesBySeq]);

  useEffect(() => {
    if (!loadingopt && option) {
      const typemc = typeMC600 === '602' ? 602 : 603;

      const clone = option.pieces_exclues_option.map((i) => ({
        ...i
      }));
      clone.sort((a, b) => a.seq - b.seq);
      setListPiecesExclues(clone);

      const clone1 = option.bom.map((i) => ({ ...i }));
      clone1.sort((a, b) => a.seq - b.seq);
      setNewBom(clone1);

      setFormDataOption({
        ...option,
        bom: null,
        typemc600: typemc
      });
    }
  }, [loadingopt, option]);

  useEffect(() => {
    //Recuperation de la liste des sequences
    if (!loadingpiece && pieces.length > 0 && (option !== null || id === '0')) {
      let items = [];
      for (let i = 1; i <= pieces.length; i++) {
        items.push(i * 10);
      }
      setListSeq(items);

      const clone = [];
      pieces.forEach((elt, index) => {
        const clone2 = [];
        elt.forEach((piece) => {
          clone2.push({
            ...piece,
            flaggedForRemoval: listPiecesExclues.some(
              (e) => e.piece._id === piece._id && e.seq === (index + 1) * 10
            )
          });
        });
        clone.push(clone2);
      });
      setListPiecesParSeq(clone);
    }
  }, [pieces, loadingpiece, option]);

  useEffect(() => {
    const navigateTo = () =>
      navigate(`/creationoption/${typeMC600}/${option._id}`);
    if (option !== null && update === true) {
      navigateTo();
    }
  }, [update, option]);

  //TODO besoin de faire des modifications sur un element particulier de la BOM, peut etre prevoir une fonction speciale pour modif element BOM (qte, refx3, etc) selon index

  const onChangeDataOption = (e, name) => {
    setFormDataOption({
      ...formDataOption,
      [name]: e[0]
    });
  };

  const onChangeDataNewBOM = (prop, event, index) => {
    const old = newBOM[index];
    const updated = { ...old, [prop]: parseInt(event.target.value, 10) };
    const clone = [...newBOM];
    clone[index] = updated;
    setNewBom(clone);
  };

  const updateItemNvellePiece = (prop, event, index) => {
    const old = newPieces[index];
    const updated = { ...old, [prop]: parseInt(event.target.value, 10) };
    const clone = [...newPieces];
    clone[index] = updated;
    setNewPieces(clone);
  };

  const onDeletePieceFormDataOption = (index) => {
    const old = newPieces[index];
    const updated = { ...old, piece: null, seq: null, visible: false };
    const clone = [...newPieces];
    clone[index] = updated;
    setNewPieces(clone);
  };

  const onDeleteItemNewBOM = (index) => {
    const old = newBOM[index];
    const updated = { ...old, piece: null };
    const clone = [...newBOM];
    clone[index] = updated;
    setNewBom(clone);
  };

  const RemovePieceFromListPieces = (indexSeq, indexPiece, removed) => {
    const oldListPieceSeq = listPiecesParSeq[indexSeq];
    const oldPiece = oldListPieceSeq[indexPiece];
    const updated = { ...oldPiece, flaggedForRemoval: removed };
    const clone = [...listPiecesParSeq];
    clone[indexSeq][indexPiece] = updated;
    setListPiecesParSeq(clone);
    if (removed) {
      const clone = [...listPiecesExclues];
      clone.push({ piece: oldPiece, seq: (indexSeq + 1) * 10 });
      setListPiecesExclues(clone);
    } else if (listPiecesExclues.length > 0) {
      let clone = listPiecesExclues.filter(
        (i) => !(i.piece._id === oldPiece._id && i.seq === (indexSeq + 1) * 10)
      );
      setListPiecesExclues([...clone]);
    }
  };

  const AddNewElementBOM = () => {
    setNewPieces((oldArray) => [
      ...oldArray,
      { seq: 0, piece: null, qte: 1, visible: true }
    ]);
  };

  const SauvegarderOption = () => {
    formDataOption.bom = [...newBOM.filter((elt) => elt.piece !== null)];

    //ajout des pieces pour les nouvelles sequence, on prend n'importe laquelle
    const newPiecesPopulated = [
      ...newPieces.filter((elt) => elt.seq !== null && elt.visible !== false)
    ];
    for (let i = 0; i < newPiecesPopulated.length; i++) {
      const old = newPiecesPopulated[i];
      const updated = {
        ...old,
        piece: listPiecesParSeq[old.seq / 10 - 1][0]
      };
      newPiecesPopulated[i] = updated;
    }

    formDataOption.bom = formDataOption.bom.concat(
      newPiecesPopulated.filter(
        (elt) => elt.piece !== null && elt.seq !== 0 && elt.visible !== false
      )
    );

    //check si les sequences des pieces exclus sont presentes dans la bom final
    const listSeqBom = formDataOption.bom
      .filter((elt) => elt.piece !== null && elt.seq !== 0)
      .map((piece) => piece.seq);
    formDataOption.pieces_exclues_option = [
      ...listPiecesExclues.filter(
        (elt) =>
          listSeqBom.includes(elt.seq) ||
          (elt.seqpossible && listSeqBom.includes(elt.seqpossible[0]))
      )
    ];
    if (formDataOption.refx3.length !== 9) {
      setAlert('La reference X3 doit faire 9 caractères', 'danger');
    }
    if (formDataOption.nom.length === 0) {
      setAlert("Veuillez entrer un nom pour l'option svp", 'danger');
    }
    if (formDataOption.bom.length === 0 && newBOM.length === 0) {
      setAlert(
        "Veuillez ajouter des pièces à la bom de l'option svp",
        'danger'
      );
    }

    if (
      formDataOption.refx3.length === 9 &&
      formDataOption.nom.length !== 0 &&
      (formDataOption.bom.length !== 0 || newBOM.length !== 0)
    ) {
      if (
        window.confirm('Etes vous sur de vouloir sauvegarder cette option ?')
      ) {
        setaction(true);

        createOption(id !== '0' ? id : null, formDataOption, navigate);
      }
    }
  };

  const EffacementOption = () => {
    if (window.confirm('Etes vous sur de vouloir supprimer cette pièce ?')) {
      setaction(true);
      createOption(option._id, { deleted: true }, navigate);
      setTimeout(() => {
        navigate(0);
      }, 1000);
    }
  };

  // si pieces.length < 40, axios a tronqué le resultat de la requete
  if ((loadingopt && id !== '0') || action || listPiecesParSeq.length < 40) {
    return <Spinner />;
  } else {
    return (
      <section className="container">
        <Fragment>
          <div style={{ marginTop: 50 }}>
            <h4 className="p-3 mb-2 bg-ascorel text-white text-center">
              {id !== '0' ? 'Modification option' : 'Creation option'}
            </h4>
            <div style={{ marginTop: 30, marginBottom: 30 }}>
              <form class="row col-12">
                <label style={labelStyle} class="col-2">
                  Nom:
                </label>
                <div class="col-10">
                  <input
                    type="text"
                    className="form-control "
                    value={formDataOption.nom}
                    onChange={(e) =>
                      onChangeDataOption([e.target.value], 'nom')
                    }
                    placeholder="Nom"
                  />
                </div>
              </form>
              <form class="row col-12">
                <label style={labelStyle} class="col-2">
                  Reference X3:
                </label>
                <div class="col-10">
                  <input
                    type="text"
                    className="form-control "
                    value={formDataOption.refx3}
                    onChange={(e) =>
                      onChangeDataOption([e.target.value], 'refx3')
                    }
                    placeholder="Reference X3"
                  />
                </div>
              </form>
              <form class="row col-12">
                <label style={labelStyle} class="col-2">
                  Type:
                </label>
                <div class="col-10">
                  <select
                    name="status"
                    value={formDataOption.typemc600}
                    className="form-control "
                    onChange={(e) =>
                      onChangeDataOption([e.target.value], 'typemc600')
                    }
                  >
                    <option value="603">MC603</option>
                    <option value="602">MC602</option>
                  </select>
                </div>
              </form>
              <form class="row col-12">
                <label style={labelStyle} class="col-2">
                  Commentaire:
                </label>
                <div class="col-10">
                  <textarea
                    className="form-control"
                    rows="2"
                    placeholder="Renseigner vos commentaires ici"
                    type="text"
                    name="commentaire"
                    value={formDataOption.commentaire}
                    onChange={(e) =>
                      onChangeDataOption([e.target.value], 'commentaire')
                    }
                  ></textarea>
                </div>
              </form>
              {/* </form> */}
            </div>
          </div>
          {/* <Fragment> */}
          {/* <div className="row"> */}
          <div className="card">
            <div className="card-header" style={headStyle}>
              BOM :
            </div>
            <div>
              <table
                className="table table-striped table-light table-header-group"
                style={{ marginTop: 5 }}
                border="1"
              >
                <thead>
                  <tr className="title-td">
                    <td id="th1" width="100" class="text-center">
                      Seq
                    </td>
                    <td className="text-center" id="th3">
                      Elements
                    </td>
                    {/* <td className="text-center" id="th3" width="100">
                      Commentaire
                    </td> */}
                    {/* <td className="text-center" id="th4">
                      réfèrence X3
                    </td> */}
                    <td className="text-center" id="th5" width="100">
                      Qté
                    </td>
                    {/* <td className="text-center" id="th6">
                      P.J
                    </td>
                    <td className="text-center" id="th6">
                      Vignette
                    </td> */}
                    <td className="text-center" id="th7" width="80"></td>
                  </tr>
                </thead>
                {/* <tr>
                  <td id="th1" colspan="12">
                    <button
                      className="btn btn-primary"
                      onClick={AddNewElementBOM}
                    >
                      Ajouter element <IoIosAddCircleOutline />
                    </button>
                  </td>
                </tr> */}
                <tbody>
                  <tr>
                    <td id="th1" colSpan="12">
                      <button
                        className="btn btn-secondary"
                        onClick={AddNewElementBOM}
                      >
                        Ajouter element <IoIosAddCircleOutline />
                      </button>
                    </td>
                  </tr>

                  <tr className="ssection-td">
                    <td id="th1" colSpan="12">
                      Elements ajoutés
                    </td>
                  </tr>
                  {newPieces.map((elt, index) =>
                    elt.visible === false ? (
                      <Fragment key={index}></Fragment>
                    ) : (
                      <tr>
                        <ElementNomenclature
                          sequence={elt.seq}
                          qte={elt.qte}
                          listePieces={
                            elt.seq !== 0
                              ? listPiecesParSeq[elt.seq / 10 - 1]
                              : []
                          }
                          onRemoveVariante={RemovePieceFromListPieces}
                          onDeletePiece={(e) =>
                            onDeletePieceFormDataOption(index)
                          }
                          listSequences={listSeq}
                          OnChangeQte={(e) =>
                            updateItemNvellePiece('qte', e, index)
                          }
                          OnChangeSeq={(e) =>
                            updateItemNvellePiece('seq', e, index)
                          }
                        />
                      </tr>
                    )
                  )}
                  {newBOM.length > 0 ? (
                    newBOM.map((elt, index) => (
                      <tr key={elt.piece._id}>
                        <ElementNomenclature
                          sequence={elt.seq}
                          qte={elt.qte}
                          listePieces={listPiecesParSeq[elt.seq / 10 - 1]}
                          onRemoveVariante={RemovePieceFromListPieces}
                          onDeletePiece={(e) => onDeleteItemNewBOM(index)}
                          listSequences={listSeq}
                          OnChangeQte={(e) =>
                            onChangeDataNewBOM('qte', e, index)
                          }
                          OnChangeSeq={(e) =>
                            onChangeDataNewBOM('seq', e, index)
                          }
                        />
                      </tr>
                    ))
                  ) : (
                    <Fragment></Fragment>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {/* </div> */}
          {/* // </Fragment> */}
          {/* <Fragment> */}
          {/* <div className="row" style={{ marginLeft: 0 }}> */}
          <div className="card">
            <div className="card-header" style={headStyle}>
              Pièces jointes :
            </div>
            <ListePiecesJointes
              OnChangePieceJointe={(list) =>
                onChangeDataOption([list], 'piecesjointes')
              }
              tailleTexte="normal"
              listPJ={formDataOption.piecesjointes}
            />
          </div>
          <div style={{ margin: 10 }}>
            <ModalImportPJ
              addPJ={(list) => onChangeDataOption([list], 'piecesjointes')}
              listPJ={formDataOption.piecesjointes}
            />
          </div>
          {/* </div> */}
          {/* // </Fragment> */}
          <div style={{ marginTop: 50 }} className="row ">
            <div className="col text-center">
              <button
                className="btn btn-secondary btn-lg center-block"
                onClick={() => navigate(-1)}
              >
                Annuler <MdCancel />
              </button>
            </div>

            <div className="col-3 text-center">
              <button
                className="btn btn-warning btn-lg float-left"
                onClick={EffacementOption}
              >
                Supprimer option <MdDelete />
              </button>
            </div>

            <div className="col text-center">
              <button
                className="btn btn-success btn-lg center-block"
                onClick={SauvegarderOption}
              >
                Sauvegarder option <MdSave />
              </button>
            </div>
          </div>
        </Fragment>
      </section>
    );
  }
};

CreationOption.propTypes = {
  auth: PropTypes.object.isRequired,
  optionfichegrue: PropTypes.object.isRequired,
  piece: PropTypes.object.isRequired,
  createOption: PropTypes.func.isRequired,
  getPiecesBySeq: PropTypes.func.isRequired,
  getOptionById: PropTypes.func.isRequired,
  setAlert: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  optionfichegrue: state.optionfichegrue,
  piece: state.piece,
  auth: state.auth
});

export default connect(mapStateToProps, {
  getOptionById,
  createOption,
  getPiecesBySeq,
  setAlert
})(CreationOption);

const headStyle = {
  fontSize: '20px',
  background: '#333355',
  color: '#fff',
  fontWeight: 'bold',
  textAlign: 'center',
  padding: 10
};

const labelStyle = {
  fontSize: '15px',
  fontWeight: 'bold',
  textAlign: 'center',
  padding: 10
};
